"use strict";

var _react = _interopRequireDefault(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _Homepage = require("../Homepage");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var container = document.getElementById('homepage');
if (container) {
  _reactDom.default.render( /*#__PURE__*/_react.default.createElement(_Homepage.Homepage, null), container);
}